import { Clock, TaskCircle } from '@doist/icons/product-ui';
import { Box, Text } from '@doist/marketist';
import { useTranslation } from 'next-i18next';
import css from './product-ui-view-header.module.css';
type ProductUIViewHeaderTodayProps = {
  tasks?: number;
  duration?: string;
};
export function ProductUIViewHeaderTodaySubtitle({
  tasks = 0,
  duration
}: ProductUIViewHeaderTodayProps) {
  const {
    t
  } = useTranslation('productui');
  return <Box tag="ul" className={css.todayViewSubtitle} data-sentry-element="Box" data-sentry-component="ProductUIViewHeaderTodaySubtitle" data-sentry-source-file="product-ui-view-header-today.tsx">
            {tasks > 0 ? <Box tag="li" className={css.todayViewItem}>
                    <TaskCircle width={24} height={24} />
                    <Text size="body-xs">{t('todayView.tasks', {
          count: tasks
        })}</Text>
                </Box> : null}
            {duration ? <Box tag="li" className={css.todayViewItem}>
                    <Clock width={24} height={24} />
                    <Text size="body-xs">{duration}</Text>
                </Box> : null}
        </Box>;
}